module.exports = __webpack_public_path__ + "static/media/mb.80e727a7.png";